import { countConversationsAssigned } from '../queries/countConversationsAssigned'

export const totalConversationsAssignedGauge = {
  description:
    'Total amount of incoming conversations, over your selected time period.',
  queries: [countConversationsAssigned],
  title: 'Assignments',
}
